webpackJsonp([2],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var View = _react2.default.createClass({
    displayName: "View",

    render: function render() {
        return _react2.default.createElement(
            "div",
            { className: "footer" },
            _react2.default.createElement(
                "p",
                null,
                "Copyright \xA9 2016-2020 www.yuanying.com All Rights Reserved \u7248\u6743\u6240\u6709\xB7\u8FDC\u5F71\u533B\u7597"
            ),
            _react2.default.createElement(
                "p",
                null,
                "\u4EACICP\u8BC1140186\u53F7 | \u7F51\u7EDC\u6587\u5316\u7ECF\u8425\u8BB8\u53EF\u8BC1\u4EAC\u7F51\u6587[2013]0918-967\u53F7 | \u4EACICP\u5907\u6848\u7F16\u53F712049600-1 | \u4EAC\u516C\u7F51\u5B89\u590711011202001441\u53F7 | \u8425\u4E1A\u6267\u7167"
            )
        );
    }
});

exports.default = View;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var View = _react2.default.createClass({
    displayName: 'View',

    render: function render() {
        var _props$className = this.props.className,
            className = _props$className === undefined ? '' : _props$className;

        return _react2.default.createElement(
            'div',
            { className: "header " + className },
            _react2.default.createElement(
                'div',
                { className: 'container clearfix' },
                _react2.default.createElement(
                    'div',
                    { className: 'fr' },
                    _react2.default.createElement('i', { className: 'iconfont icon-tel' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'tel' },
                        '\u5BA2\u670D\u7535\u8BDD\uFF1A400-626-9912'
                    )
                ),
                _react2.default.createElement('a', { href: '/', className: 'logo' })
            )
        );
    }
});

exports.default = View;

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(42);
module.exports = __webpack_require__(65);


/***/ }),

/***/ 129:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ajax;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _login = __webpack_require__(17);

var _login2 = _interopRequireDefault(_login);

var _stats = __webpack_require__(22);

var _stats2 = _interopRequireDefault(_stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ajax(data) {
    var _beforeSend = data.beforeSend,
        _success = data.success,
        _error2 = data.error;
    return _jquery2.default.ajax(_jquery2.default.extend({ cache: false }, data, {
        beforeSend: function beforeSend(xhr) {
            var info = _login2.default.getInfo();
            xhr.setRequestHeader("X-YY-TOKEN", info.token);
            if (_beforeSend) {
                _beforeSend(xhr);
            }
        },
        success: function success(result) {
            if (result && result.code == 40001) {
                window.location.href = "/login.html?callbackUrl=" + encodeURIComponent(location.href);
                return;
            }
            if (_success) {
                _success(result);
            }
        },
        error: function error(xhr, errorType, _error) {
            _stats2.default.trackEvent('ajax', 'error', xhr.status, xhr.responseURL);
            if (_error2) {
                _error2(xhr, errorType, _error);
            }
        }
    }));
} /**
   * Created by emma on 16/12/3.
   */

/***/ }),

/***/ 130:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(4);

var _ajax = __webpack_require__(13);

var _ajax2 = _interopRequireDefault(_ajax);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Created by emma on 16/3/24.
 */
var Cookie = __webpack_require__(27);
exports.default = {
    isLogined: function isLogined() {
        var token = Cookie.get('X-YY-TOKEN');
        return token;
    },
    getInfo: function getInfo(key) {
        var json = {
            token: Cookie.get('X-YY-TOKEN')
        };
        return key ? json[key] : json;
    },
    redirectToLogin: function redirectToLogin() {
        if (!this.isLogined()) {
            window.location.href = "/login.html?callbackUrl=" + encodeURIComponent(location.href);
            return false;
        }
        return true;
    },
    logout: function logout() {
        (0, _ajax2.default)({
            url: _config.apiUrl + '/user/logout',
            type: 'post',
            dataType: "json",
            success: function success(result) {
                if (result && result.code == 0) {
                    window.location.href = '/';
                }
            }
        });
    }
};

/***/ }),

/***/ 18:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by emma on 17/1/20.
 */
var stats = {
    init: function init() {
        window.onerror = function (msg, url, line, col, error) {
            _hmt.push(['_trackEvent', 'window', 'error', msg, url + ',' + line + ',' + col]);
        };
    },
    trackEvent: function trackEvent(category) {
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';
        var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '-';
        var value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '-';

        _hmt.push(['_trackEvent', category, action, label, value]);
    }
};

exports.default = stats;

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//Thanks :
// - https://github.com/aralejs/cookie/blob/master/src/cookie.js

var decode, encode;

decode = decodeURIComponent; //解码
encode = encodeURIComponent; //编码

exports.get = function (key, options) {
    var cookies, converter, raw;

    validate(key);
    options = options || {};
    raw = options.raw || false;
    converter = options.converter || function (o) {
        return o;
    };

    cookies = parseCookie(document.cookie, !raw);
    return converter(cookies[key]);
};

exports.set = function (key, value, options) {
    var expires, domain, path, text, date;

    validate(key);
    options = options || {};
    expires = options['expires'];
    domain = options['domain'];
    path = options['path'];

    if (!options['raw']) {
        value = encode(String(value));
    }

    text = key + '=' + value;
    date = expires;

    if (typeof date === 'number') {
        date = new Date();
        date.setDate(date.getDate() + expires);
    }

    if (date instanceof Date) {
        text += '; expires=' + date.toUTCString();
    }

    if (domain && domain.length) {
        text += '; domain=' + domain;
    }

    if (path && path.length) {
        text += '; path=' + path;
    }

    //http://www.oschina.net/question/8676_3423 secure作用
    if (options['secure']) {
        text += '; secure';
    }

    document.cookie = text;
    return text;
};

exports.remove = function (key, options) {
    options = options || {};
    options['expires'] = new Date(0);
    return this.set(key, '', options);
};

//把document.cookie字符串解析为{cookieName : cookieValue}
function parseCookie(text, shouldDecode) {
    var i, len, cookies, decodeValue, cookieParts, cookieName, cookieValue, cookieNameValue;

    cookies = {};
    decodeValue = shouldDecode ? decode : function (o) {
        return o;
    };
    cookieParts = text.split(/;\s/g);

    for (i = 0, len = cookieParts.length; i < len; i++) {
        cookieNameValue = cookieParts[i].match(/([^=]+)=/i);
        if (cookieNameValue instanceof Array) {
            try {
                cookieName = decode(cookieNameValue[1]);
                cookieValue = decodeValue(cookieParts[i].substring(cookieNameValue[1].length + 1));
            } catch (e) {}
        } else {
            cookieName = decode(cookieParts[i]);
            cookieValue = '';
        }

        if (cookieName) {
            cookies[cookieName] = cookieValue;
        }
    }

    return cookies;
}

function validate(key) {
    if (!(key && key.length)) {
        throw new TypeError('Cookie name must be a non-empty string');
    }
}

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * Created by emma on 15/12/18.
                                                                                                                                                                                                                                                                               */


exports.in_array = in_array;
exports.getNameById = getNameById;
exports.isArray = isArray;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function in_array(arr, item) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';

    var result = -1;
    if (arr && arr.length && typeof item != 'undefined') {
        _jquery2.default.each(arr, function (index, it) {
            if (typeof it != 'undefined') {
                if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) == 'object') {
                    if (it[key] == item[key]) {
                        result = index;
                        return false;
                    }
                } else {
                    if (it[key] == item) {
                        result = index;
                        return false;
                    }
                }
            }
        });
    }
    return result;
}

function getNameById(arr, id) {
    var name = '';
    arr.some(function (item) {
        if (item.id == id) {
            name = item.name;
            return true;
        }
    });
    return name;
}

function isArray(value) {
    return Object.prototype.toString.call(value) == '[object Array]';
}

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DELETE_ITEM = exports.UPDATE_ITEM = exports.RECEIVE_ERROR = exports.EXPIRED_DATA = exports.RECEIVE_DATA = exports.REQUEST_DATA = exports.ajaxStoreName = undefined;
exports.requestData = requestData;
exports.receiveData = receiveData;
exports.receiveError = receiveError;
exports.updateItem = updateItem;
exports.deleteItem = deleteItem;
exports.expiredData = expiredData;
exports.fetchDataIfNeeded = fetchDataIfNeeded;
exports.getItemById = getItemById;

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = __webpack_require__(13);

var _ajax2 = _interopRequireDefault(_ajax);

var _array = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ajaxStoreName = exports.ajaxStoreName = 'ajaxData'; /**
                                                         * Created by houyulei on 2016/5/17.
                                                         */
var REQUEST_DATA = exports.REQUEST_DATA = 'REQUEST_DATA';
var RECEIVE_DATA = exports.RECEIVE_DATA = 'RECEIVE_DATA';
var EXPIRED_DATA = exports.EXPIRED_DATA = "EXPIRED_DATA";
var RECEIVE_ERROR = exports.RECEIVE_ERROR = 'RECEIVE_ERROR';
var UPDATE_ITEM = exports.UPDATE_ITEM = 'UPDATE_ITEM';
var DELETE_ITEM = exports.DELETE_ITEM = 'DELETE_ITEM';

//meta:{viewName,viewItemKey,viewItemsKey,api}

function requestData(meta, params) {
    return {
        type: REQUEST_DATA, meta: meta, params: params
    };
}

function receiveData(meta, params, result) {
    return {
        type: RECEIVE_DATA, meta: meta, params: params, result: result
    };
}

function receiveError(meta, result) {
    return { type: RECEIVE_ERROR, meta: meta, result: result };
}

function updateItem(meta, item) {
    return { type: UPDATE_ITEM, meta: meta, item: item };
}
function deleteItem(meta, item) {
    return { type: DELETE_ITEM, meta: meta, item: item };
}

function expiredData(meta) {
    return { type: EXPIRED_DATA, meta: meta };
}

function fetchData(meta, params) {
    return function (dispatch) {
        dispatch(requestData(meta, params));
        (0, _ajax2.default)({
            type: 'get',
            dataType: 'json',
            url: meta.api,
            data: params,
            success: function success(result) {
                if (result && result.code == 0) {
                    var obj = result;
                    if (meta.viewItemsKey) {
                        if ((0, _array.isArray)(result[meta.viewItemsKey])) {
                            obj.items = result[meta.viewItemsKey];
                        } else {
                            obj.items = [result[meta.viewItemsKey]];
                        }
                    } else if (meta.getViewItems) {
                        obj.items = meta.getViewItems(result);
                    }
                    dispatch(receiveData(meta, params, obj));
                } else {
                    dispatch(receiveError(meta, {
                        code: '50x',
                        message: '服务器出错了'
                    }));
                }
            },
            error: function error(xhr) {
                try {
                    var responseJSON = xhr.responseJSON;
                    dispatch(receiveError(meta, responseJSON));
                } catch (e) {
                    dispatch(receiveError(meta, {
                        Code: '50x',
                        Message: '服务器出错了'
                    }));
                }
            }
        });
    };
}

function shouldFetchData(state, meta) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var viewName = meta.viewName,
        _meta$viewItemKey = meta.viewItemKey,
        viewItemKey = _meta$viewItemKey === undefined ? 'id' : _meta$viewItemKey;

    var model = state[ajaxStoreName][viewName];
    var result = true;
    if (model) {
        var oldMeta = model.meta;
        if (params && params[viewItemKey]) {
            //查询单个item
            if (model.currentItem && model.currentItem.item && model.currentItem.item[viewItemKey] == params[viewItemKey]) {
                result = false;
            } else if (model.items && model.items.length) {
                var index = (0, _array.in_array)(model.items, params[viewItemKey], viewItemKey);
                if (index > -1) {
                    result = false;
                }
            } else {
                result = !model.fetching;
            }
        } else if (oldMeta && oldMeta.api == meta.api) {
            var oldParams = _jquery2.default.extend({ page: 1 }, model.params),
                newParams = _jquery2.default.extend({ page: 1 }, params);
            if (_jquery2.default.param(oldParams) === _jquery2.default.param(newParams)) {
                result = false;
            }
        }
    }

    return result;
}

function fetchDataIfNeeded(meta, params) {
    return function (dispatch, getState) {
        if (!shouldFetchData(getState(), meta, params)) {
            return Promise.resolve();
        } else {
            return dispatch(fetchData(meta, params));
        }
    };
}

function getItemById(data, meta, params) {
    var _meta$viewItemKey2 = meta.viewItemKey,
        viewItemKey = _meta$viewItemKey2 === undefined ? 'id' : _meta$viewItemKey2;


    if (!data || data.fetching || !data.fetching && !data.items && !data.error) {
        return { fetching: true };
    }
    var currentItem = data.currentItem;

    if (currentItem && currentItem.item && currentItem.item[viewItemKey] == params[viewItemKey]) {
        return currentItem.item;
    }

    var index = (0, _array.in_array)(data.items, params[viewItemKey], viewItemKey);
    if (index > -1) {
        return data['items'][index];
    }
    return data;
}

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by emma on 16/11/29.
 */
var apiUrl = exports.apiUrl = '/api';
var dicomUrl = exports.dicomUrl = '/dicom/api';
var picUrl = exports.picUrl = 'http://img.11zhushou.com/';
var basepath = exports.basepath = '';

var caseStatus = exports.caseStatus = [{ id: '100', name: '草稿', key: 'allDraft' }, { id: '201', name: '待接收', key: 'allWaitToTake' }, { id: '301', name: '待确认', key: 'allWaitToConfirm' }, { id: '501', name: '被退回', key: 'allRejected' }, { id: '401', name: '已完成', key: 'allFinished' }];

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _footer = __webpack_require__(10);

var _footer2 = _interopRequireDefault(_footer);

var _header = __webpack_require__(11);

var _header2 = _interopRequireDefault(_header);

var _topbar = __webpack_require__(71);

var _topbar2 = _interopRequireDefault(_topbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = _react2.default.createClass({
    displayName: 'App',

    render: function render() {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_topbar2.default, null),
            _react2.default.createElement(_header2.default, { className: 'header-b' }),
            this.props.children,
            _react2.default.createElement(_footer2.default, null)
        );
    }
});

module.exports = App;

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setViewScrollTop = setViewScrollTop;
exports.resetScrollTop = resetScrollTop;
/**
 * Created by houyulei on 2016/5/19.
 */
var SET_VIEW_SCROLL_TOP = exports.SET_VIEW_SCROLL_TOP = "SET_VIEW_SCROLL_TOP";
var RESET_SCROLL_TOP = exports.RESET_SCROLL_TOP = 'RESET_SCROLL_TOP';

function setViewScrollTop(path, top) {
    return { type: SET_VIEW_SCROLL_TOP, path: path, top: top };
}

function resetScrollTop() {
    return { type: RESET_SCROLL_TOP };
}

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(6);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

__webpack_require__(12);

var _redux = __webpack_require__(16);

var _reduxThunk = __webpack_require__(35);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactRedux = __webpack_require__(21);

var _reactRouter = __webpack_require__(20);

var _createBrowserHistory = __webpack_require__(45);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _reactRouterRedux = __webpack_require__(34);

var _reducer = __webpack_require__(75);

var _reducer2 = _interopRequireDefault(_reducer);

var _action = __webpack_require__(43);

var _router = __webpack_require__(77);

var _router2 = _interopRequireDefault(_router);

var _login = __webpack_require__(17);

var _login2 = _interopRequireDefault(_login);

var _stats = __webpack_require__(22);

var _stats2 = _interopRequireDefault(_stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_stats2.default.init();

var browserHistory = (0, _reactRouter.useRouterHistory)(_createBrowserHistory2.default)(); //{queryKey: false}

var createStoreWithMiddleware = (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default), (0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(browserHistory)), window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
})(_redux.createStore);
var reducer = (0, _redux.combineReducers)(_jquery2.default.extend({}, _reducer2.default, {
    routing: _reactRouterRedux.routerReducer
}));

var loginUser = _login2.default.getInfo();

var store = createStoreWithMiddleware(reducer, {
    loginUser: loginUser
});

var history = (0, _reactRouterRedux.syncHistoryWithStore)(browserHistory, store);

var rootElement = document.getElementById("root");

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(_reactRouter.Router, { history: history, routes: _router2.default })
), rootElement);

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(4);

exports.default = {
    viewName: 'userInfo',
    viewItemsKey: 'info',
    api: _config.apiUrl + '/doctor/info'
};

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _login = __webpack_require__(17);

var _login2 = _interopRequireDefault(_login);

var _reactRedux = __webpack_require__(21);

var _config = __webpack_require__(4);

var _redux = __webpack_require__(16);

var _action = __webpack_require__(38);

var _ajaxConfig = __webpack_require__(70);

var _ajaxConfig2 = _interopRequireDefault(_ajaxConfig);

var _reactRouter = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var View = _react2.default.createClass({
    displayName: 'View',

    render: function render() {
        var item = this.props.item;

        return _react2.default.createElement(
            'div',
            { className: 'topbar' },
            _react2.default.createElement(
                'div',
                { className: 'container' },
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/' },
                    _react2.default.createElement('i', { className: 'iconfont icon-home' }),
                    '\u8FD4\u56DE\u9996\u9875'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'fr' },
                    item.name,
                    '\uFF0C\u6B22\u8FCE\u4F60\uFF01',
                    _react2.default.createElement(
                        'a',
                        { href: 'javascript:;', className: 'special', onClick: this.logout },
                        '\u9000\u51FA',
                        _react2.default.createElement('i', { className: 'iconfont icon-logout' })
                    )
                )
            )
        );
    },
    logout: function logout() {
        _login2.default.logout();
    },
    componentDidMount: function componentDidMount() {
        this.props.fetchDataIfNeeded(_ajaxConfig2.default);
    }
});

function mapStateToProps(state) {
    var list = state.ajaxData[_ajaxConfig2.default.viewName],
        userInfo = { fetching: true };
    if (list && !list.fetching && list.items.length) {
        Object.assign(userInfo, list.items[0], { fetching: list.fetching });
    }
    return {
        item: userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchDataIfNeeded: (0, _redux.bindActionCreators)(_action.fetchDataIfNeeded, dispatch)
    };
}

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(View);

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _action = __webpack_require__(38);

var _jquery = __webpack_require__(2);

var _jquery2 = _interopRequireDefault(_jquery);

var _array = __webpack_require__(37);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Created by emma on 15/12/14.
                                                                                                                                                                                                                   */


//meta:{viewName,viewItemKey,viewItemsKey,viewOrder}
//store:{items,pagination,fetching}
function data() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { fetching: false, items: [], total: 0, error: false };
    var action = arguments[1];
    var _action$meta = action.meta,
        meta = _action$meta === undefined ? {} : _action$meta,
        _action$params = action.params,
        params = _action$params === undefined ? { page: 1 } : _action$params;
    var viewItemKey = meta.viewItemKey;

    var result = action.result;
    switch (action.type) {
        case _action.REQUEST_DATA:
            return _jquery2.default.extend({}, state, {
                fetching: true,
                meta: meta,
                params: params,
                error: false
            });
        case _action.RECEIVE_DATA:
            return _jquery2.default.extend({}, state, {
                fetching: false,
                items: result.items,
                total: result.count,
                error: false
            });
        case _action.UPDATE_ITEM:
            var items = state.items,
                newItems; //items是数组
            var index = (0, _array.in_array)(items, action.item, viewItemKey);
            if (index != -1) {
                newItems = [].concat(items.slice(0, index), _jquery2.default.extend({}, items[index], action.item), items.slice(index + 1));
                return _jquery2.default.extend({}, state, { items: newItems });
            }
            return state;
        case _action.RECEIVE_ERROR:
            return _jquery2.default.extend({}, state, {
                fetching: false,
                error: true,
                items: [],
                total: 0,
                message: result.message,
                code: result.code
            });
        case _action.EXPIRED_DATA:
            return _jquery2.default.extend({}, state, {
                fetching: false,
                items: [],
                total: 0,
                meta: {},
                error: false
            });
        default:
            return state;
    }
}

function ajaxData() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var meta = action.meta || {};
    var viewName = meta.viewName;


    switch (action.type) {
        case _action.REQUEST_DATA:
        case _action.RECEIVE_DATA:
        case _action.RECEIVE_ERROR:
        case _action.EXPIRED_DATA:
        case _action.UPDATE_ITEM:
        case _action.DELETE_ITEM:
            return _jquery2.default.extend({}, state, _defineProperty({}, viewName, data(state[viewName], action)));
        default:
            return state;
    }
}

exports.default = ajaxData;

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.showLoading = showLoading;
exports.hideLoading = hideLoading;
var SHOW_LOADING = exports.SHOW_LOADING = "SHOW_LOADING";
var HIDE_LOADING = exports.HIDE_LOADING = "HIDE_LOADING";

function showLoading(msg) {
    return { type: SHOW_LOADING, msg: msg };
}
function hideLoading() {
    return { type: HIDE_LOADING };
}

/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _action = __webpack_require__(73);

function fullLoading() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case _action.SHOW_LOADING:
            return {
                isShow: true,
                msg: action.msg
            };
        case _action.HIDE_LOADING:
            return {
                isShow: false
            };
        default:
            return state;

    }
}

exports.default = fullLoading;

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reducer = __webpack_require__(76);

var _reducer2 = _interopRequireDefault(_reducer);

var _reducer3 = __webpack_require__(74);

var _reducer4 = _interopRequireDefault(_reducer3);

var _reducer5 = __webpack_require__(72);

var _reducer6 = _interopRequireDefault(_reducer5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loginUser() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    return state;
}

var rootReducer = {
    scrollTop: _reducer2.default,
    fullLoading: _reducer4.default,
    loginUser: loginUser,
    ajaxData: _reducer6.default
};

exports.default = rootReducer;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _action = __webpack_require__(43);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Created by houyulei on 2016/5/19.
 */
var $ = __webpack_require__(2);


function scrollTop() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _action.SET_VIEW_SCROLL_TOP:
            return $.extend({}, state, _defineProperty({}, action.path, action.top));
        case _action.RESET_SCROLL_TOP:
            return {};
        default:
            return state;

    }
}

exports.default = scrollTop;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _config = __webpack_require__(4);

var routeConfig = {
    path: _config.basepath + '/',
    getIndexRoute: function getIndexRoute(location, cb) {
        __webpack_require__.e/* require.ensure */(0).then((function (require) {
            cb(null, {
                component: __webpack_require__(132)
            });
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    },
    getChildRoutes: function getChildRoutes(location, callback) {
        __webpack_require__.e/* require.ensure */(1).then((function (require) {
            callback(null, [__webpack_require__(133), __webpack_require__(134), __webpack_require__(131)]);
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
    }
}; /**
    * Created by emma on 16/9/21.
    */
exports.default = routeConfig;

/***/ })

},[127]);


// WEBPACK FOOTER //
// index.js